import React from 'react';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message }) => {
  return (
    <div className="loading-spinner-backdrop">
      <div className="loading-spinner-content">
        <div className="loading-logo-ring">
          <div className="loading-ring loading-ring-outer" />
          <div className="loading-ring loading-ring-inner" />
          <img
            src="/logo.png"
            alt="Loading"
            className="loading-logo-img"
          />
        </div>
        <p className="loading-label">{message || 'Loading'}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;